import gql from 'graphql-tag'

export const SET_CHANNEX_ENABLED_MUTATION = gql`
  mutation SetChannexEnabled (
    $enabled: Boolean!
  ) {
    setChannexEnabled (enabled: $enabled)
  }
`
